const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');

function getQS(parsedMetaData) {
  return {
    userId: parsedMetaData.qs.userId,
    branchCode: parsedMetaData.portfolio.branchCode
  };
}

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    Accept: 'application/json',
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    saveCurrency(currency, metaData) {
      const url = getUrl('set-user-pref-refccy');
      const parsedMetaData = parseRequestMetaData(metaData);
        const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true,
      };

      const params = { prefRefCcy: currency };
      const body = merge(getQS(parsedMetaData), params);

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    getCurrency(metaData) {
      const url = getUrl('get-user-pref-refccy');
      const parsedMetaData = parseRequestMetaData(metaData);
        const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true,
      };

      const body = getQS(parsedMetaData);

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    }
  };
}

module.exports = apiFactory;
